
import { Route, Routes } from 'react-router-dom'

import AddEditSubmission from '../add-edit-submission'
import ViewSubmissions from '../view-submissions'

const AddEditFbtRoutes = () => (
  <Routes>
    <Route path="add-submission" element={<AddEditSubmission />} />
    <Route path="edit-submission" element={<AddEditSubmission />} />
    <Route path="view-submissions" element={<ViewSubmissions />} />
  </Routes>
)

export default AddEditFbtRoutes
